// localStorage implementation
import StorageInterface from './StorageInterface';
class LocalStorageAdapter extends StorageInterface {
    get(key) {
        const data = localStorage.getItem(key);
        return data ? JSON.parse(data) : null;
    }
    save(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
    remove(key) {
        localStorage.removeItem(key);
    }
}
export default LocalStorageAdapter;
